import {DEVICE_TYPES} from 'Utils/constants';

const isPreviewMode = () =>
    typeof window?.location?.host === 'string' &&
    new URL(window.location).searchParams.get(DEVICE_TYPES.PREVIEW.toLowerCase()) === 'y';
export default isPreviewMode;
